import React, { useEffect, useContext, useState } from 'react';
import { firestore } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { AppContext } from './AppContext';
import { useNavigate } from 'react-router-dom';

const FadeInImage = ({ src, alt, className }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onLoad={() => setLoaded(true)}
      style={{
        opacity: loaded ? 1 : 0,
        transition: 'opacity 0.5s ease-in-out'
      }}
    />
  );
};

const HomePage = () => {
  const { assetsSummary, setAssetsSummary } = useContext(AppContext);
  const [totalStreams, setTotalStreams] = useState('');
  const navigate = useNavigate(); // Initialize navigation



  const handleAssetClick = (asset) => {
    console.log('Navigating to asset detail for:', asset);
    navigate(`/viewdat`, { state: { asset } });
  };

  return (
    <div className="homepage-container">
      {/* Total Streams field */}
      <div className="streams-container">
        <label htmlFor="totalStreams">Total Streams: 547,467</label>
      </div>

      <div className="assets-container">
        {assetsSummary.length > 0 ? (
          <ul className="assets-list">
            {assetsSummary.map((asset, index) => (
              <li 
                key={index} 
                className="asset-item" 
                onClick={() => handleAssetClick(asset)}
              >
                <FadeInImage
                  src={asset.ArtworkURL}
                  alt={`Artwork for ${asset.creatorUsername}`}
                  className="asset-image"
                />
                <div className="asset-info">
                  <div className="asset-artist">{asset.SongName}</div>
                  <div className="asset-song">{asset.ArtistName}</div>
                  <div className="asset-creator">@{asset.creatorUsername}</div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No assets to display.</p>
        )}
      </div>

<style>{`
  :root{
    --brand-top:#fe24ad;
    --brand-bot:#a410e8;
    --brand-grad:linear-gradient(135deg,var(--brand-top),var(--brand-bot));
    --brand-top-20:rgba(254,36,173,.2);
    --brand-bot-40:rgba(164,16,232,.4);
  }

  /* GLOBAL RESETS & SCROLLBAR STYLING */
  *{margin:0;padding:0;box-sizing:border-box;}
  html,body{font-family:sans-serif;background:#000;color:#fff;}
  .homepage-container{min-height:100vh;padding:2rem;display:flex;flex-direction:column;}


  /* PAGE CONTAINER */
  .homepage-container{
    width:100%;
    min-height:100vh;
    background:#000;
    padding:2rem;
    display:flex;
    flex-direction:column;
    animation:fadeInPage 1s ease-in-out;
  }
  @keyframes fadeInPage{from{opacity:0;}to{opacity:1;}}

  /* Total Streams Field */
  .streams-container{
    margin-bottom:1rem;
    display:flex;
    align-items:center;
  }
  .streams-container label{
    font-weight:bold;
    margin-right:0.5rem;
    font-size:1rem;
    background:var(--brand-grad);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .streams-input{
    width:120px;
    padding:0.25rem 0.5rem;
    font-size:1rem;
    border:1px solid var(--brand-bot-40);
    border-radius:4px;
    background:#050008;
    color:#fff;
  }
  .streams-input:focus{
    outline:none;
    border-color:var(--brand-top);
    box-shadow:0 0 6px var(--brand-top);
  }

  /* ASSETS CONTAINER */
  .assets-container{
    flex:1;
    -webkit-overflow-scrolling:touch;
    overflow-y:auto; 
    padding:1rem 0 0 0;
  }
  .assets-list{
    list-style:none;
    display:grid;
    grid-template-columns:repeat(2,1fr);
    grid-gap:1rem;
  }

  .asset-item{
    display:flex;
    align-items:center;
    background:#050008;
    padding:1rem;
    border-radius:8px;
    border:1px solid var(--brand-bot-40);
    box-shadow:0 2px 6px rgba(0,0,0,.45);
    transition:transform .3s ease, box-shadow .3s ease;
    opacity:0;
    animation:fadeInAsset .5s forwards;
    cursor:pointer;
  }
  .asset-item:hover{
    transform:translateY(-5px);
    box-shadow:0 4px 14px rgba(164,16,232,.35);
  }
  @keyframes fadeInAsset{to{opacity:1;}}

  .asset-image{
    width:50px;
    height:50px;
    object-fit:cover;
    border-radius:8px;
    margin-right:1rem;
    border:2px solid var(--brand-top);
  }

  .asset-info{display:flex;flex-direction:column;}
  .asset-info>div{margin-bottom:0.25rem;font-size:0.9rem;}
  .asset-artist{
    font-weight:bold;
    background:var(--brand-grad);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .asset-song{
    font-style:italic;
    color:rgba(255,255,255,.75);
  }
  .asset-creator{
    color:rgba(255,255,255,.55);
  }

  p{text-align:center;color:rgba(255,255,255,.75);}

  /* MOBILE */
  @media (max-width:600px){
    .homepage-container{padding:0 1rem;}
    .streams-container{margin-top:1.5rem;}
    .assets-list{grid-template-columns:1fr;}
  }
`}</style>

    </div>
  );
};

export default HomePage;
